import React from 'react'

const TravelDeskContext = React.createContext({
  ExpInfo: {},
  updateExpInfo: () => {},
})

export default TravelDeskContext
